import React, { useContext, useState } from 'react';
import { Pressable, View } from 'react-native';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import ComponentTitle from '../common/ComponentTitle';
import { H4 } from '../text';
import LayoutContext from '../../contexts/Layout';
import { StyledWebView } from '../common/StyledWebView';

const AccordionItem = ({ isOpen, layout, richTextContent, nodeTypeAlias = 'AccordionItem', setOpenKey, title, width }) => {
    const style = {
        borderColor: '#dde4e9',
        borderTopWidth: 1
    };

    return (
        <Pressable onPress={() => setOpenKey()} style={style} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            <View>
                <View
                    style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', paddingVertical: layout.styleGuide.spacer3 }}
                    dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})`, spacerTop: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
                >
                    <H4 text={title} />
                    <FontAwesome6 name={isOpen ? 'caret-up' : 'caret-down'} size={20} color='#000' />
                </View>
                {isOpen && (
                    <View
                        style={{ marginTop: layout.styleGuide.spacer2, paddingRight: layout.styleGuide.spacer1 + layout.styleGuide.indent }}
                        dataSet={{
                            spacerTop: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`,
                            spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})+StyleGuide.Indent(${layout.styleGuide.indent})`
                        }}
                    >
                        <StyledWebView html={richTextContent} width={width} />
                    </View>
                )}
            </View>
        </Pressable>
    );
};

AccordionItem.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    setOpenKey: PropTypes.func.isRequired
};

const Accordion = ({ contentItems, nodeTypeAlias, title, width }) => {
    const { layout } = useContext(LayoutContext);
    const [openKey, setOpenKey] = useState();

    return (
        <View
            style={{ marginBottom: layout.styleGuide.componentSeparator, marginLeft: layout.styleGuide.spacer1, marginRight: 0 }}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`,
                spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`
            }}
        >
            <ComponentTitle
                dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                style={{ paddingBottom: layout.styleGuide.spacer2 }}
                title={title}
            />

            <View
                style={{ marginHorizontal: layout.styleGuide.indent }}
                dataSet={{ spacerLeft: `StyleGuide.Indent(${layout.styleGuide.indent})`, spacerRight: `StyleGuide.Indent(${layout.styleGuide.indent})` }}
            >
                {Object.values(contentItems).map((item, index) => {
                    const {key, ...props} = item;
                    return (<AccordionItem
                        {...props}
                        key={key}
                        layout={layout}
                        isOpen={openKey === item.id}
                        setOpenKey={() => setOpenKey(k => (k === item.id ? undefined : item.id))}
                        width={width}
                    />)
                })}
            </View>
        </View>
    );
};

Accordion.propTypes = {
    contentItems: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Accordion;
